import { render, staticRenderFns } from "./Ideal.vue?vue&type=template&id=2164d149&scoped=true&"
import script from "./Ideal.vue?vue&type=script&lang=js&"
export * from "./Ideal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164d149",
  null
  
)

export default component.exports